<template>
  <Card>
    <span slot="title">操作员管理</span>
    <el-button slot="btn" icon="el-icon-refresh" @click="$refresh(getScanList)" class="fr">刷新</el-button>
    <div slot="content" class="scanwrap">
      <!-- 条件查询 -->
      <div class="search"> 
        <el-form :inline="true" :model="searchForm">
          <el-form-item label="姓名">
            <el-input v-model="searchForm.scanCodeUserName" placeholder="请输入姓名"/>
          </el-form-item>
          <el-form-item label="手机号">
            <el-input v-model="searchForm.phone" placeholder="请输入手机号"/>
          </el-form-item>
          <el-form-item label="医馆" v-if="!deptId">
            <el-select v-model="searchForm.deptId" placeholder="请选择医馆">
              <el-option v-for="item in deptOptions" :key="item.value"  :label="item.label" :value="item.value"/>
            </el-select>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="searchForm.status" filterable default-first-option placeholder="请选择操作员状态">
              <el-option v-for="item in [{label: '全部', value: null}, {label: '在职', value: '0'}, {label: '离职', value: '1'}]" :key="item.value" :label="item.label" :value="item.value"/>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="$refresh(getScanList, true)">查询</el-button>
            <el-button icon="el-icon-refresh" @click="$reset(getScanList, { scanCodeUserName: null, phone: null, deptId: null, status: null })">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 操作按钮 -->
      <div class="button">
        <el-button icon="el-icon-plus" type="primary" @click="addScan" v-if="deptId">新增操作员</el-button>
        <el-button icon="el-icon-download" type="primary" @click="downloadScan">批量下载</el-button>
      </div>
      <!-- 操作员列表 -->
      <el-table v-loading="loading" :data="scanList" :max-height="tableHeight" border>
        <el-table-column type="index" label="序号" width="50"/>
        <el-table-column prop="scanCodeUserName" label="姓名"/>
        <el-table-column prop="sex" label="性别" min-width="50">
          <template slot-scope="scope">
            {{scope.row.sex == '0' ? '男' : '女'}}
          </template>
        </el-table-column>
        <el-table-column prop="phone" label="手机号" min-width="120"/>
        <el-table-column prop="permission" label="权限" min-width="180"/>
        <el-table-column prop="deptName" label="所属医馆" v-if="!deptId"/>
        <el-table-column prop="status" label="状态" min-width="90">
          <template slot-scope="scope">
            {{scope.row.status == '0' ? '在职' : '离职'}}
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" min-width="160"/>
        <el-table-column label="操作" width="280">
          <template slot-scope="scope">
            <el-button type="primary" @click="editScan(scope.row)">编辑</el-button>
            <el-button type="primary" @click="showImg(scope.row.scanCodeUserId)">图码</el-button>
            <el-button type="primary" @click="download(scope.row.scanCodeUserId, scope.row.scanCodeUserName)">下载</el-button>
            <el-button type="danger" :disabled="scope.row.status == '1'" @click="dimission(scope.row)">停职</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 新增或编辑弹框 -->
      <el-dialog class="scanEdit" :title="dialogTitle" :visible.sync="dialogVisible"
        width="360px" :before-close="done => $handleClose(done, 'editForm')" :close-on-click-modal="false">
        <el-form :model="editForm" ref="editForm" :rules="editFormRules" inline>
          <el-form-item label="姓名" prop="scanCodeUserName">
            <el-input v-model="editForm.scanCodeUserName" placeholder="请输入姓名"/>
          </el-form-item>
          <el-form-item label="性别" prop="sex">
            <el-radio-group v-model="editForm.sex">
              <el-radio :label="'0'">男</el-radio>
              <el-radio :label="'1'">女</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="电话" prop="phone">
            <el-input v-model="editForm.phone" placeholder="请输入手机号"/>
          </el-form-item>
          <el-form-item label="权限" prop="permission">
            <el-select v-model="editForm.permission" multiple placeholder="请选择操作权限">
              <el-option v-for="item in operationOptions" :key="item"  :label="item" :value="item"/>
            </el-select>
          </el-form-item>
          <el-form-item label="状态" prop="status">
            <el-radio-group v-model="editForm.status">
              <el-radio :label="'0'">在职</el-radio>
              <el-radio :label="'1'">离职</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <!-- 操作按钮 -->
        <span slot="footer" class="dialog-footer">
          <el-button type="success" v-if="dialogTitle == '新增操作员'" @click="addSave">保存新增</el-button>
          <el-button type="success" v-if="dialogTitle == '编辑操作员'" @click="editSave">保存修改</el-button>
          <el-button @click="$cancel('dialogVisible', 'editForm')">取 消</el-button>
        </span>
      </el-dialog>
      <el-dialog title="操作员微信绑定二维码展示" :visible.sync="imgVisible" width="480px" :before-close="$handleClose" :close-on-click-modal="false">
        <iframe :src="'https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=' + imgParam" id="QRCode" 
        scrolling="no" frameborder="0" style="width: 480px; height: 480px;"></iframe>
        <!-- 操作按钮 -->
        <span slot="footer" class="dialog-footer">
          <el-button @click="imgVisible = false">关 闭</el-button>
        </span>
      </el-dialog>
      <!-- 分页 -->
        <el-pagination @current-change="page => $handleCurrentChange(page, getScanList)" :total="total"
        :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper"/>
    </div>
  </Card>
</template>

<script lang="js">
import axios from 'axios'; // 引入axios
import { scanList, scanEdit, scanAdd, scanInfo, scanImg } from "@/api/scan"; // 获取操作员请求
export default {
  name: "Scan",
  data() {
    return {
      loading: true, // 加载中
      searchForm: { scanCodeUserName: null, phone: null, deptId: null, status: null }, // 查询表单
      scanList: [], // 操作员列表
      currentPage: 1, // 当前页
      pageSize: 10, // 显示条数
      total: 0, // 总条数
      dialogTitle: null, // 弹框标题
      dialogVisible: false, // 新增或编辑弹框状态
      imgVisible: false, // 图片弹框
      editForm: {}, // 新增或编辑表单
      normalizer(obj) { // 键名转换，方法默认是label和children进行树状渲染
        return { id: obj.menuId, label: obj.menuName }
      },
      editFormRules: {
        scanCodeUserName: [{required: true, message: "姓名不能为空！", trigger: "blur"}],
        phone: [{required: true, message: "手机号不能为空！", trigger: "change"}],
        permission: [{required: true, message: "操作权限不能为空！", trigger: "change"}],
        sex: [{required: true}],
        status: [{required: true}],
      }, // 验证规则
      deptId: this.$session.get('deptId'), // 当前医馆id
      deptOptions: this.$session.get('options'), // 医馆列表
      operationOptions: ['审方', '配方', '打包', '加工', '配送'], // 操作列表
      imgParam: null, // 二维码转码字符串
      tableHeight: 0, // 表格最大高度
    };
  },
  created() {
    if (document.documentElement.clientWidth > 1292) this.tableHeight = document.documentElement.clientHeight - 310;
    else this.tableHeight = document.documentElement.clientHeight - 350;
    this.getScanList(); // 请求操作员列表
  },
  methods: {
    // 请求所有操作员列表
    async getScanList() {
      let params = { pageNum: this.currentPage, pageSize: this.pageSize, ...this.searchForm };
      let { total, rows, code } = await scanList(params);
      if (code == 200) {
        if (total > 0) rows.forEach(item => {
          item.permission = item.permission.replace(/,/g, ',  ');
          this.deptOptions.forEach(items => {
            if (item.deptId == items.value) item.deptName = items.label;
          })
        });
        this.total = total;
        this.scanList = rows;
      }
      this.loading = false;
    },
    // 新增操作员
    addScan() {
      this.dialogVisible = true;
      this.dialogTitle = "新增操作员";
      this.editForm = { scanCodeUserName: null, permission: [], sex: '0', status: '0', deptId: this.deptId };
    },
    // 保存新增
    addSave() {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          scanAdd(this.handle()).then(res => {
            let {code} = res;
            if (code == 200) this.$message.success("新增操作员成功！");

            this.dialogVisible = false;
            this.$refresh(this.getScanList);
            this.$refs['editForm'].resetFields();
          });
        } else return false;
      })
    },
    // 处理参数
    handle() {
      let params = JSON.parse(JSON.stringify(this.editForm));
      let permission = JSON.stringify(params.permission);
      params.permission = permission.substring(1, permission.length - 1).replace(/"/g, '');
      return params;
    },
    // 编辑操作员信息
    async editScan(row) {
      let { data, code } = await scanInfo(row.scanCodeUserId);
      if (code == 200) {
        data.permission = JSON.parse('["' + data.permission.replace(/,/g, '","') + '"]');
        this.editForm = data;
        this.dialogTitle = "编辑操作员";
        this.dialogVisible = true;
      }
    },
    // 保存操作员修改
    editSave() {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          scanEdit(this.handle()).then(res => {
            let {code} = res;
            if (code == 200) this.$message.success("修改操作员成功！");
            this.dialogVisible = false;
            this.$refresh(this.getScanList);
            this.$refs['editForm'].resetFields();
          })
        } else return false;
      })
    },
    // 操作员停职
    dimission(row) {
      row.status = '1';
      this.$confirm('确认停职操作员？停职后将不能进行扫码操作！').then(_ => {
        scanEdit(row).then(res => {
          if (res.code == 200) {
            this.$message.success('该操作员停职成功，现已不能进行扫码操作！');
            this.$refresh(this.getScanList);
          }
        })
      }).catch(_ => {});
    },
    // 下载图片
    download(scanCodeUserId, name) {
      axios({
        method: "get",
        url: this.$baseUrl + '/order/scan/user/downFile/' + scanCodeUserId,
        responseType:"blob"
      }).then(res => {
        const link = document.createElement('a');
        let objectUrl = window.URL.createObjectURL(res.data); // 创建URL
        link.href = objectUrl;
        link.download = name + '.png'; // 自定义文件名
        link.click(); // 下载文件
        URL.revokeObjectURL(objectUrl); // 释放内存
      });
    },
    // 批量下载
    downloadScan() {
      axios({
        method: "get",
        url: this.$baseUrl + '/order/scan/user/downFiles',
        responseType:"blob"
      }).then(res => {
        const link = document.createElement('a');
        let objectUrl = window.URL.createObjectURL(res.data); // 创建URL
        link.href = objectUrl;
        link.download = '二维码.zip'; // 自定义文件名
        link.click(); // 下载文件
        URL.revokeObjectURL(objectUrl); // 释放内存
      });
    },
    // 查看二维码
    async showImg(scanCodeUserId) {
      let {code, data} = await scanImg(scanCodeUserId);
      if (code == 200) {
        this.imgParam = data;
        this.imgVisible = true;
      }
    }
  },
};
</script>

<style lang="less" scoped>
.scanwrap {
  & > div:not(:last-child) {
    margin-bottom: 20px;
  }
  .scanEdit {
    .el-form-item {
      width: 460px;
    }
    /deep/.el-input, /deep/.el-form-item__content {
      width: 270px;
    }
  }
}
</style>